import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

/**
 * Anonymous search statistic. Call this from a search form's submit handler only, never from a page
 * load or an effect: a page load is what crawlers do, a submit is what a visitor does. Fire and forget;
 * the token, if any, only lets the server leave admin sessions out.
 */
export function recordSearch(zip, industry) {
  if (!/^\d{5}$/.test(zip || "")) return;
  const token = localStorage.getItem("ndr_token");
  axios.post(`${API}/searches`, { zip_code: zip, ...(industry ? { industry } : {}) },
    token ? { headers: { Authorization: `Bearer ${token}` } } : undefined).catch(() => {});
}
